import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-message-body',
    templateUrl: './message-body.component.html',
    styleUrls: ['./message-body.component.css']
})
export class MessageBodyComponent implements OnInit {
    @Input() data;

    getFileName(url) {
        var index = url.lastIndexOf('/');
        if (index == -1) {
            return url;
        }
        return url.slice(index + 1);
    }

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/message-list/message-body/message-body.component.ts